var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendar({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "26px",
    height: "29px",
    viewBox: "0 0 26 29",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon/Calender") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon/Calender",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-11",
    transform: "translate(1.000000, 0.000000)",
    fill: "#B7844D"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-1",
    points: "5.41157221 12.983354 7.37200654 12.983354 7.37200654 11.4427793 5.41157221 11.4427793"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-2",
    points: "11.0185929 12.983354 12.9787297 12.983354 12.9787297 11.4427793 11.0185929 11.4427793"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-3",
    points: "16.6279935 12.983354 18.5884278 12.983354 18.5884278 11.4427793 16.6279935 11.4427793"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-4",
    points: "5.41157221 17.1792161 7.37200654 17.1792161 7.37200654 15.6395379 5.41157221 15.6395379"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-5",
    points: "11.0185929 17.1792161 12.9787297 17.1792161 12.9787297 15.6395379 11.0185929 15.6395379"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-6",
    points: "16.6279935 17.1792161 18.5884278 17.1792161 18.5884278 15.6395379 16.6279935 15.6395379"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-7",
    points: "5.41157221 21.3759747 7.37200654 21.3759747 7.37200654 19.8362966 5.41157221 19.8362966"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-8",
    points: "11.0185929 21.3759747 12.9787297 21.3759747 12.9787297 19.8362966 11.0185929 19.8362966"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-9",
    points: "16.6279935 21.3759747 18.5884278 21.3759747 18.5884278 19.8362966 16.6279935 19.8362966"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3453815,0 L16.3453815,1.78503448 L7.65313104,1.78503448 L7.65313104,0 L6.35638852,0 L6.35638852,1.78503448 L0,1.78503448 L0,26 L24,26 L23.9988101,1.78503448 L17.6424215,1.78503448 L17.6424215,0 L16.3453815,0 Z M17.643314,4.3916092 L17.643314,3.04678161 L22.7449055,3.04678161 L22.7449055,7.78894253 L1.25479697,7.78894253 L1.25479697,3.04678161 L6.35638852,3.04678161 L6.35638852,4.3916092 L7.65313104,4.3916092 L7.65313104,3.04678161 L16.346869,3.04678161 L16.346869,4.3916092 L17.643314,4.3916092 Z M1.25479697,24.7382529 L22.7437156,24.7382529 L22.7437156,9.09163218 L1.25479697,9.09163218 L1.25479697,24.7382529 Z",
    id: "Fill-10"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.16a43f09222de042c6931af82b58cb47.svg";
export { ForwardRef as ReactComponent };